import { Route, RouteGroup } from '@billow/easy-route'

export default RouteGroup({

  routes: [
    Route('/labels', 'label-index', () => import(`@/views/label/Index`)),
    Route('/label', 'create-label', () => import(`@/views/label/Create`)),
    Route('/label/:label', 'label-manager', () => import(`@/views/label/Manager`)),
  ]
})